import { render, staticRenderFns } from "./ConfigsTable.vue?vue&type=template&id=3475429b"
import script from "./ConfigsTable.vue?vue&type=script&lang=js"
export * from "./ConfigsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports